import { render, staticRenderFns } from "./resetPassword.vue?vue&type=template&id=3f8619ea&scoped=true&"
import script from "./resetPasswordControl.js?vue&type=script&lang=js&"
export * from "./resetPasswordControl.js?vue&type=script&lang=js&"
import style0 from "./resetPassword.css?vue&type=style&index=0&id=3f8619ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8619ea",
  null
  
)

export default component.exports